import React from "react"

const LoadingScreen = () => {
  return (
    <div className="flex h-screen w-full flex-col px-8 pb-8 pt-32">
      <h1 className="mb-4 text-4xl font-bold text-nelo-blue">Lo sentimos, no podemos aprobar tu solicitud de crédito</h1>
      <p className="mb-8 text-ui-fg-base">
        Nelo es un producto de crédito, y usamos datos de tu reporte crediticio y otras fuentes oficiales para evaluar tu aplicación.
        Desafortunadamente, hoy no podemos aprobar tu aplicación.
      </p>
      <p className="mb-8 text-ui-fg-base">
        La mejor forma de calificar para Nelo, es establecer un historial de uso de crédito responsable y hacer tus pagos a tiempo.
      </p>
    </div>
  )
}

export default LoadingScreen
